/* @flow */
import Group from 'entities/Group';

// virtual id, not in the database
const rootGroupId = -1;

export const rootGroupCode = 'r';
export default class RootGroup extends Group {

  initialize() {
    this.id = rootGroupId;
  }

  isRoot() {
    return true;
  }

  getName() {
    // not concerned yet with localization
    return 'All classes';
  }

  getCode() {
    return rootGroupCode;
  }

  getType() {
    return 'root';
  }

  isStaffClass() {
    return false;
  }

  canAddPeople() {
    return false;
  }

  canJoin() {
    return false;
  }

  canEdit() {
    return false;
  }

  canLeave() {
    return false;
  }

  /**
   * @deprecated. Use postable roles instead.
   */
  canPost() {
    return true;
  }

  getPostableRoles() {
    return [];
  }

  canDelete() {
    return false;
  }

  isSMSEnabled() {
    return false;
  }

  hasShortCode() {
    return false;
  }

  isAvailable() {
    return false;
  }

  isSubscribed() {
    return false;
  }

  isOwnedByUser() {
    return false;
  }

  getPermissions() {
    return {};
  }

  getAvatarUrl() {
    return require('assets/images/avatars/home.svg');
  }

  getAccentColor() {
    return '#2f75c1';
  }

  getOwners() {
    throw new Error('unsupported operation for RootGroup');
  }

  setName() {
    throw new Error('unsupported operation for RootGroup');
  }

  getPdfUrl() {
    return ''; // TODO: Where is this invoked?
  }

  getJoinUrl() {
    throw new Error('unsupported operation for RootGroup');
  }

  hasChildren() {
    throw new Error('unsupported operation for RootGroup');
  }

  setHasChildren() {
    throw new Error('unsupported operation for RootGroup');
  }

  getMembershipsCount() {
    return 0; // TODO: Where is this invoked?
  }

  getSubscriptionInfo() {
    throw new Error('unsupported operation for RootGroup');
  }

  useShortCodeForUser() {
    throw new Error('unsupported operation for RootGroup');
  }

  smsEnabledForUser() {
    throw new Error('unsupported operation for RootGroup');
  }

  getStaffClassOrgId() {
    return null;
  }

  getOrganization() {
    return null;
  }

  setOrganization() {
    throw new Error('unsupported operation for RootGroup');
  }

  getMessagesCount() {
    throw new Error('unsupported operation for RootGroup');
  }

  isMessageHistoryEnabled() {
    throw new Error('unsupported operation for RootGroup');
  }

  getLastReadSeq() {
    throw new Error('unsupported operation for RootGroup');
  }

  canSubscribersInitiateChats() {
    throw new Error('unsupported operation for RootGroup');
  }

  setCanSubscribersInititateChats() {
    throw new Error('unsupported operation for RootGroup');
  }

  getPossessiveName() {
    throw new Error('unsupported operation for RootGroup');
  }

  getSMSNumber() {
    throw new Error('unsupported operation for RootGroup');
  }

  getSMSAlternateNumber() {
    throw new Error('unsupported operation for RootGroup');
  }

  getEmail() {
    throw new Error('unsupported operation for RootGroup');
  }

  isSearchable() {
    return true;
  }

  setSearchable() {
    throw new Error('unsupported operation for RootGroup');
  }

  getAvatar() {
    throw new Error('unsupported operation for RootGroup');
  }

  getAvatarId() {
    throw new Error('unsupported operation for RootGroup');
  }

  setAvatar() {
    throw new Error('unsupported operation for RootGroup');
  }

  setLastReadSeq() {
    throw new Error('unsupported operation for RootGroup');
  }

  getUserId() {
    throw new Error('unsupported operation for RootGroup');
  }

  getUserSignature() {
    throw new Error('unsupported operation for RootGroup');
  }

  getState() {
    throw new Error('unsupported operation for RootGroup');
  }

  setState() {
    throw new Error('unsupported operation for RootGroup');
  }

  loadPotentialOwners() {
    throw new Error('unsupported operation for RootGroup');
  }

  loadGroupMemberships() {
    throw new Error('unsupported operation for RootGroup');
  }

  promoteGroupMemberships() {
    throw new Error('unsupported operation for RootGroup');
  }

  resignOwnership() {
    throw new Error('unsupported operation for RootGroup');
  }

  removeMember() {
    throw new Error('unsupported operation for RootGroup');
  }

  removeAllMembers() {
    throw new Error('unsupported operation for RootGroup');
  }

  addSubscribers() {
    throw new Error('unsupported operation for RootGroup');
  }

  subscribe() {
    throw new Error('unsupported operation for RootGroup');
  }

  unsubscribe() {
    throw new Error('unsupported operation for RootGroup');
  }

}

export const rootGroup = new RootGroup();



// WEBPACK FOOTER //
// ./src/entities/RootGroup.js